const TransferIcon = ({
  width=32, 
  height=32,
  color,
  uniqueId,
  radiosColor1,
  radiosColor2,
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="16" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill={`url(#${uniqueId})`} />
      <circle r="14" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill="white"/>
      <path d="M22.6665 16C22.6665 12.32 19.6798 9.33337 15.9998 9.33337C12.3198 9.33337 9.33317 12.32 9.33317 16C9.33317 19.68 12.3198 22.6667 15.9998 22.6667C19.6798 22.6667 22.6665 19.68 22.6665 16ZM17.9998 12.3334L20.0998 14.4334C20.2332 14.5667 20.2332 14.7734 20.0998 14.9067L17.9998 17L17.9998 15.3334L15.3332 15.3334L15.3332 14L17.9998 14L17.9998 12.3334ZM11.8998 17.5667C11.7665 17.4334 11.7665 17.2267 11.8998 17.0934L13.9998 15L13.9998 16.6667L16.6665 16.6667L16.6665 18L13.9998 18L13.9998 19.6667L11.8998 17.5667Z" fill={color} />
      <defs>
        <linearGradient id={uniqueId} x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor={radiosColor1} />
          <stop offset="0.885417" stopColor={radiosColor2} />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default TransferIcon;
